module.exports = __webpack_public_path__ + "static/media/aboutBackground.cead75aa.jpg";